import config from '../monetization.config.json';
import { trackUsage } from './metrics';

export function validateKoFiUrl(value: string, kind: 'support' | 'product'): string | null {
  if (!value) return null;
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.hostname !== 'ko-fi.com' || url.port || url.username || url.password || url.hash || url.search) return null;
    const pattern = kind === 'product' ? /^\/s\/[A-Za-z0-9]+\/?$/ : /^\/[A-Za-z0-9_]+\/?$/;
    return pattern.test(url.pathname) ? url.href : null;
  } catch { return null; }
}

export function commerceState(input: { supportUrl: string; productUrl: string } = config) {
  return {
    supportUrl: validateKoFiUrl(input.supportUrl, 'support'),
    productUrl: validateKoFiUrl(input.productUrl, 'product'),
  };
}

// Only literal, validated owner configuration reaches these attributes. No query
// values, file names, workspace content, or migration data go to checkout.
export function bindCommerce(root: ParentNode = document, input: { supportUrl: string; productUrl: string } = config): void {
  const state = commerceState(input);
  for (const kind of ['product', 'support'] as const) {
    root.querySelectorAll<HTMLAnchorElement>(`[data-commerce="${kind}"]`).forEach((link) => {
      const url = state[`${kind}Url`];
      if (!url) {
        link.removeAttribute('href');
        link.removeAttribute('target');
        link.setAttribute('aria-disabled', 'true');
        link.textContent = kind === 'product' ? '$9 kit · checkout not open yet' : '$1 support · not connected yet';
        return;
      }
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.referrerPolicy = 'no-referrer';
      link.removeAttribute('aria-disabled');
      link.textContent = kind === 'product' ? 'Get the kit — $9 one-time ↗' : 'Support Relay Rescue — $1 ↗';
      link.addEventListener('click', () => trackUsage(kind === 'product' ? 'kit-checkout-click' : 'support-checkout-click'));
    });
  }
  root.querySelectorAll<HTMLElement>('[data-commerce-status]').forEach((node) => {
    const kind = node.dataset.commerceStatus;
    node.textContent = kind === 'product'
      ? state.productUrl ? 'Ko-fi checkout opens in a new tab. Digital files are delivered by Ko-fi after payment. No subscription.' : 'The kit is prepared, but checkout is not open. Nothing can be purchased or charged here yet. Preview it below.'
      : state.supportUrl ? 'Optional one-time support through Ko-fi. Check that the amount is $1 USD and recurring support is off before paying. Not a charitable donation.' : 'Optional support will open once our Ko-fi payment page is connected. The analyzer stays free either way.';
  });
}
